import { apiInstance } from 'api/utils';

export default {
  getGlossary: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/glossary/'
    });
  }
};
